import * as React from "react";

function SvgUserCardDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M.125 0h23.75c.069 0 .125.056.125.125v23.75a.125.125 0 01-.125.125H.125A.125.125 0 010 23.875V.125C0 .056.056 0 .125 0z" />
        <path
          fill="#374151"
          d="M17 2.25A4.75 4.75 0 0121.75 7v10A4.75 4.75 0 0117 21.75H7A4.75 4.75 0 012.25 17V7A4.75 4.75 0 017 2.25zm0 1.5H7A3.25 3.25 0 003.75 7v10A3.25 3.25 0 007 20.25h10A3.25 3.25 0 0020.25 17V7A3.25 3.25 0 0017 3.75zm-2.791 9.5a3.55 3.55 0 013.541 3.542v.542c0 .78-.636 1.416-1.417 1.416H7.667a1.419 1.419 0 01-1.417-1.417v-.542a3.55 3.55 0 013.542-3.541zM12 5.25c1.927 0 3.5 1.567 3.5 3.489 0 1.925-1.575 3.511-3.5 3.511a3.502 3.502 0 01-3.5-3.489c0-1.925 1.575-3.511 3.5-3.511z"
        />
        <path
          fill="#98DB69"
          d="M14.209 14.75l.152.006a2.05 2.05 0 011.889 2.036v.458h-8.5v-.459c0-1.12.92-2.041 2.042-2.041h4.417zM12 6.75c1.1 0 2 .897 2 1.989 0 1.099-.906 2.011-2 2.011-1.1 0-2-.897-2-1.989 0-1.099.906-2.011 2-2.011z"
        />
      </g>
    </svg>
  );
}

export default SvgUserCardDuo;
